import axios from 'axios';

const API_URL = 'https://qwikbistro.shop';
// const TOKEN = "ad269451f183b23a15385b4c00469e6e62daef98";
const TOKEN = process.env.REACT_APP_QWIK_BISTRO_API_TOKEN;


const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const couponApiService = {
  // Get all coupons
  getAllCoupons: async () => {
    try {
      const response = await axiosInstance.get('/promoOffers/');
      return response.data.sort((a, b) => b.id - a.id); // Latest first
    } catch (error) {
      console.error('Error fetching coupons:', error);
      throw error;
    }
  },

  // Get single coupon
  getCoupon: async (id) => {
    try {
      const response = await axiosInstance.get(`/promoOffers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching coupon:', error);
      throw error;
    }
  },

  // Update coupon
  updateCoupon: async (id, couponData) => {
    try {
      const response = await axiosInstance.patch(`/promoOffers/${id}`, couponData);
      return response.data;
    } catch (error) {
      console.error('Error updating coupon:', error);
      throw error;
    }
  },

  // Delete coupon
  deleteCoupon: async (id) => {
    try {
      await axiosInstance.delete(`/promoOffers/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting coupon:', error);
      throw error;
    }
  },

  // Create new coupon
  createCoupon: async (couponData) => {
    try {
      const response = await axiosInstance.post('/promoOffers/new', couponData);
      return response.data;
    } catch (error) {
      console.error('Error creating coupon:', error);
      throw error;
    }
  },
};